export const FEATURE_NAME = 'matches';

export const ID = '_id';

export const STATUS = 'status';
export const USER = 'user';
export const INSTITUTION = 'institution';
